import { NavLink } from 'react-router'
import styles from './MediaSectionTabs.module.css'
import { MEDIA_SECTIONS } from '../config/studioRoutes'

export default function MediaSectionTabs() {
  return (
    <nav className={styles.tabs} aria-label="Library sections">
      {MEDIA_SECTIONS.map(({ to, label }) => (
        <NavLink
          key={to}
          to={to}
          end
          className={({ isActive }) => (isActive ? `${styles.tab} ${styles.tabActive}` : styles.tab)}
        >
          {label}
        </NavLink>
      ))}
    </nav>
  )
}
